<template>
    <div class="blog-list">
      <h2>Dental Care Tips</h2>
      <div v-for="post in posts" :key="post.id" class="post">
        <h3>{{ post.title }}</h3>
        <p>{{ post.excerpt }}</p>
        <router-link :to="`/blog/${post.id}`">Read More</router-link>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        posts: []
      };
    },
    mounted() {
      fetch('https://your-backend-api.com/blog')
        .then(res => res.json())
        .then(data => this.posts = data);
    }
  };
  </script>